export default __webpack_public_path__ + "media/images/banners/months/bnr_3-b0c0f276b22b451b0be095b939d6fc82.jpg";